// Skeleton Loader Component
const PostSkeleton = () => (
  <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6 animate-pulse border border-stone-200">
    {/* Header Skeleton */}
    <div className="flex items-center justify-between p-4 border-b border-stone-200">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 rounded-full bg-stone-200"></div>
        <div>
          <div className="h-4 w-32 bg-stone-200 rounded mb-2"></div>
          <div className="h-3 w-24 bg-stone-200 rounded"></div>
        </div>
      </div>
      <div className="w-6 h-6 bg-stone-200 rounded-full"></div>
    </div>
    
    {/* Content Skeleton */}
    <div className="p-4">
      <div className="h-4 bg-stone-200 rounded mb-3 w-full"></div>
      <div className="h-4 bg-stone-200 rounded mb-3 w-3/4"></div>
      <div className="h-4 bg-stone-200 rounded mb-4 w-1/2"></div>
      
      <div className="relative pt-[56.25%] rounded-lg overflow-hidden bg-stone-200"></div>
    </div>
    
    {/* Actions Skeleton */}
    <div className="px-4 py-2 border-t border-stone-200">
      <div className="flex justify-between items-center">
        <div className="h-8 w-20 bg-stone-200 rounded-lg"></div>
        <div className="h-8 w-24 bg-stone-200 rounded-lg"></div>
        <div className="h-8 w-20 bg-stone-200 rounded-lg"></div>
      </div>
    </div>
  </div>
);

export default PostSkeleton;